import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = ["onClick"]

import { ref, PropType, watch, onMounted, computed } from 'vue';
import { StoryItem } from '@/models/story-item.model';
import { Action } from '@/models/action.model';
import { Initiative } from '@/models/initiative.model';
import { useStore } from 'vuex';
import { ShiftCMSState } from '@/store';
import { StoriesState } from '@/stores/stories.store';
import { ContentStoreActions, ContentStoreState } from '@/stores/content.store';


export default /*@__PURE__*/_defineComponent({
  __name: 'ActionsInitiativesContentForm',
  props: {
  modelValue: { type: Object as PropType<StoryItem>, required: true },
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const store = useStore<
  ShiftCMSState & { ts: StoriesState; cns: ContentStoreState }
>();
const props = __props;
const value = ref<StoryItem>({ ...props.modelValue });
const showAddAction = ref<boolean>(false);
const showAddInitiative = ref<boolean>(false);

const actions = computed<Action[]>(() => store.state.cns.actions);
const initiatives = computed<Initiative[]>(() => store.state.cns.initiatives);

const addableAction = ref<Action[]>([]);
const addableInitiative = ref<Initiative[]>([]);

const emit = __emit;

const update = () => {
  emit('update:modelValue', value.value);
};
watch(
  () => props.modelValue,
  () => {
    Object.assign(value.value, props.modelValue);
  },
  { deep: true },
);

onMounted(() => {
  store.dispatch(ContentStoreActions.GetActions);
  store.dispatch(ContentStoreActions.GetInitiatives);
});

function toggleAddAction() {
  showAddAction.value = !showAddAction.value;
}
function toggleAddInitiative() {
  showAddInitiative.value = !showAddInitiative.value;
}

function addAction() {
  if (addableAction.value) {
    value.value.actions = value.value.actions = [
      ...value.value.actions,
      ...addableAction.value,
    ];
    update();
  }
  addableAction.value = [];
}
function addInitiative() {
  if (addableInitiative.value) {
    value.value.initiatives = value.value.initiatives = [
      ...value.value.initiatives,
      ...addableInitiative.value,
    ];
    update();
  }
  addableInitiative.value = [];
}

function removeAction(id: number) {
  value.value.actions = [...value.value.actions].filter((a) => a.id !== id);
  update();
}
function removeInitiative(id: number) {
  value.value.initiatives = [...value.value.initiatives].filter(
    (a) => a.id !== id,
  );
  update();
}

const headers = [
  { title: 'Title', key: 'title', width: '70%' },
  { title: 'Options', key: 'options' },
];

const searchInitiative = ref<string>('');
const searchAction = ref<string>('');

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, null, {
          default: _withCtx(() => [
            _cache[7] || (_cache[7] = _createElementVNode("h4", null, "Actions", -1)),
            _createVNode(_component_v_data_table, {
              items: __props.modelValue.actions,
              headers: headers
            }, {
              headers: _withCtx(({ columns, isSorted, getSortIcon, toggleSort }) => [
                _createElementVNode("tr", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columns, (column, index) => {
                    return (_openBlock(), _createElementBlock("th", {
                      key: column.key || `c-${index}`
                    }, [
                      _createElementVNode("span", {
                        class: "mr-2 cursor-pointer",
                        onClick: () => toggleSort(column)
                      }, _toDisplayString(column.title), 9, _hoisted_1),
                      (isSorted(column))
                        ? (_openBlock(), _createBlock(_component_v_icon, {
                            key: 0,
                            icon: getSortIcon(column)
                          }, null, 8, ["icon"]))
                        : _createCommentVNode("", true),
                      (column.title === 'Options')
                        ? (_openBlock(), _createBlock(_component_v_dialog, {
                            key: 1,
                            width: "500px",
                            height: "500px",
                            scrollable: ""
                          }, {
                            activator: _withCtx(({ props: activatorProps }) => [
                              _createVNode(_component_v_btn, _mergeProps({
                                density: "compact",
                                icon: "mdi-plus",
                                onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleAddAction())),
                                ref_for: true
                              }, activatorProps), null, 16)
                            ]),
                            default: _withCtx(({ isActive }) => [
                              _createVNode(_component_v_card, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_card_text, null, {
                                    default: _withCtx(() => [
                                      _cache[6] || (_cache[6] = _createElementVNode("h4", null, "Select an action to add", -1)),
                                      _createVNode(_component_v_text_field, {
                                        label: "Filter",
                                        modelValue: searchAction.value,
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchAction).value = $event)),
                                        density: "compact",
                                        clearable: ""
                                      }, null, 8, ["modelValue"]),
                                      _createVNode(_component_v_radio_group, {
                                        multiple: "",
                                        modelValue: addableAction.value,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((addableAction).value = $event)),
                                        messages: "Select an action to add"
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([...actions.value]
                              .filter((i) =>
                                searchAction.value?.length
                                  ? i.title.toLowerCase().includes(searchAction.value)
                                  : true,
                              )
                              .filter(
                                (a) =>
                                  !value.value.actions
                                    .map((x) => x.id)
                                    .includes(a.id),
                              ), (action) => {
                                            return (_openBlock(), _createBlock(_component_v_radio, {
                                              key: action.id,
                                              label: action.title,
                                              value: action
                                            }, null, 8, ["label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_divider),
                                  _createVNode(_component_v_card_actions, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_btn, {
                                        text: "Close",
                                        onClick: ($event: any) => (isActive.value = false)
                                      }, null, 8, ["onClick"]),
                                      _createVNode(_component_v_spacer),
                                      _createVNode(_component_v_btn, {
                                        color: "surface-variant",
                                        text: "Add",
                                        variant: "flat",
                                        onClick: ($event: any) => {
                            addAction();
                            isActive.value = false;
                          }
                                      }, null, 8, ["onClick"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ])
              ]),
              "item.options": _withCtx(({ item }) => [
                _createVNode(_component_v_btn, {
                  density: "compact",
                  icon: "mdi-delete-outline",
                  onClick: ($event: any) => (removeAction(item.id))
                }, null, 8, ["onClick"])
              ]),
              _: 1
            }, 8, ["items"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, null, {
          default: _withCtx(() => [
            _cache[9] || (_cache[9] = _createElementVNode("h4", null, "Initiatives", -1)),
            _createVNode(_component_v_data_table, {
              items: __props.modelValue.initiatives,
              headers: headers
            }, {
              headers: _withCtx(({ columns, isSorted, getSortIcon, toggleSort }) => [
                _createElementVNode("tr", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columns, (column, index) => {
                    return (_openBlock(), _createElementBlock("th", {
                      key: column.key || `c-${index}`
                    }, [
                      _createElementVNode("span", {
                        class: "mr-2 cursor-pointer",
                        onClick: () => toggleSort(column)
                      }, _toDisplayString(column.title), 9, _hoisted_2),
                      (isSorted(column))
                        ? (_openBlock(), _createBlock(_component_v_icon, {
                            key: 0,
                            icon: getSortIcon(column)
                          }, null, 8, ["icon"]))
                        : _createCommentVNode("", true),
                      (column.title === 'Options')
                        ? (_openBlock(), _createBlock(_component_v_dialog, {
                            key: 1,
                            width: "500px",
                            height: "500px",
                            scrollable: ""
                          }, {
                            activator: _withCtx(({ props: activatorProps }) => [
                              _createVNode(_component_v_btn, _mergeProps({
                                density: "compact",
                                icon: "mdi-plus",
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (toggleAddInitiative())),
                                ref_for: true
                              }, activatorProps), null, 16)
                            ]),
                            default: _withCtx(({ isActive }) => [
                              _createVNode(_component_v_card, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_card_text, null, {
                                    default: _withCtx(() => [
                                      _cache[8] || (_cache[8] = _createElementVNode("h4", null, "Select an initiative to add", -1)),
                                      _createVNode(_component_v_text_field, {
                                        label: "Filter",
                                        modelValue: searchInitiative.value,
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((searchInitiative).value = $event)),
                                        density: "compact",
                                        clearable: ""
                                      }, null, 8, ["modelValue"]),
                                      _createVNode(_component_v_radio_group, {
                                        multiple: "",
                                        modelValue: addableInitiative.value,
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((addableInitiative).value = $event))
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([...initiatives.value]
                              .filter((i) =>
                                searchInitiative.value?.length
                                  ? i.title
                                      .toLowerCase()
                                      .includes(searchInitiative.value)
                                  : true,
                              )
                              .filter(
                                (a) =>
                                  !value.value.initiatives
                                    .map((x) => x.id)
                                    .includes(a.id),
                              ), (initiative) => {
                                            return (_openBlock(), _createBlock(_component_v_radio, {
                                              key: initiative.id,
                                              label: initiative.title,
                                              value: initiative
                                            }, null, 8, ["label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_divider),
                                  _createVNode(_component_v_card_actions, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_btn, {
                                        text: "Close",
                                        onClick: ($event: any) => (isActive.value = false)
                                      }, null, 8, ["onClick"]),
                                      _createVNode(_component_v_spacer),
                                      _createVNode(_component_v_btn, {
                                        color: "surface-variant",
                                        text: "Add",
                                        variant: "flat",
                                        onClick: ($event: any) => {
                            addInitiative();
                            isActive.value = false;
                          }
                                      }, null, 8, ["onClick"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ])
              ]),
              "item.options": _withCtx(({ item }) => [
                _createVNode(_component_v_btn, {
                  density: "compact",
                  icon: "mdi-delete-outline",
                  onClick: ($event: any) => (removeInitiative(item.id))
                }, null, 8, ["onClick"])
              ]),
              _: 1
            }, 8, ["items"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})